import React, { useRef, useState, useEffect } from "react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

// import { NavLink } from "react-router-dom";
import { FilterMatchMode } from "primereact/api";
// import { InputText } from "primereact/inputtext";
// import { Button } from 'primereact/button'
// import ButtonFeature from "../../features/Button.jsx";
import "primeicons/primeicons.css";

// import { AiFillDelete } from "react-icons/ai";
// import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from "primereact/tabview";
import instance from "../../api/api.js";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";

import AllCompomentShared from "../../shared/compoments/AllCompomentShared.jsx";
import { MdOutlineDelete } from "react-icons/md";
import { styleIcone } from "../../shared";
import { MenuPoint, ModalDelete } from "../../shared/compoments";
// import { IoPersonOutline } from "react-icons/io5"
import { GoHome } from "react-icons/go";

function ListeTypes() {

  // const MySwal = withReactContent(Swal);

  const [types, setTypes] = useState([]);
  // const [typesId, setTypesId] = useState("");
  // const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);


  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    libelle: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    tarif: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    duree: { value: null, matchMode: FilterMatchMode.EQUALS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  // const action = ({ id }) => {
  //   const deletetypes = () => {
  //     setTypesId(id);
  //     console.log(typesId);
  //     setShowModal(true);
  //   };
  //   return (
  //     <button
  //       className="btn bg-danger text-light fw-bold"
  //       onClick={deletetypes}
  //     >
  //       <AiFillDelete /> Supprimer
  //     </button>
  //   );
  // };
  const getListOftypes = async () => {
    try {
      const response = await instance.get("types");
      console.log(response.data);
      console.log(response.data.data);
      setTypes(response.data.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getListOftypes();
  }, []);

  // const removeTypes = async (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);
  //   try {
  //     const response = await instance.delete(`types/${typesId}`);
  //     console.log("RESPONSE", response);
  //     if (response.data.status === false) {
  //       MySwal.fire({
  //         title: response.data.message,
  //         icon: "info",
  //         showConfirmButton: true,
  //       });
  //       setIsLoading(false);
  //     } else {
  //       MySwal.fire({
  //         title: response.data.message,
  //         icon: "info",
  //         showConfirmButton: true,
  //       });
  //       setTypesId("");
  //       setShowModal(false);
  //       setIsLoading(false);
  //       getListOftypes();
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     MySwal.fire({
  //       title: error.data.message,
  //       icon: "info",
  //       showConfirmButton: true,
  //     });
  //   }
  // };

  return (
//     <div className="conteneur-page">
//         <Dialog header="Suppression" visible={showModal} style={{ width: '50vw' }} onHide={() => {if (!showModal) return; setShowModal(false); }}>
//         <form onSubmit={removeTypes} className="text-center">
//             <h5 className="m-2">Voulez-vous supprimer ce type ?</h5>
//             <ButtonFeature
//               titre="Confirmer"
//               styleBtn={styleBtn}
//               isLoading={isLoading}
//             />
//             <button
//               className="btn-lg bg-danger mx-2 border-0 rounded-3 p-2 text-light fw-bold"
//               onClick={(e) => {
//                 e.preventDefault();
//                 setShowModal(false);
//               }}
//             >
//               Annuler
//             </button>
//           </form>
// </Dialog>
//       <h1>Liste des Types de biens</h1>

      
//     </div>
<AllCompomentShared
    libelleHeaderComp={"Liste des types de biens"}
    titleStatisticHeaderComp={"Nombre de types de biens"}
    nbreTotalStatistiqueComp={types.length}
    SearchTableIsSearch={true}
    placeholderInputSearch={"Recherche"}
    globalFilterValue={globalFilterValue}
    onGlobalFilterChange={onGlobalFilterChange}
    iconeStatistiqueHeader={<GoHome fontSize={"2em"}/>} 
    isLoading={isLoading}
  >
    <TypeDatatable
        items={types}
        filters={filters}
      />
  </AllCompomentShared>
  );
}
export function TypeDatatable({ items,filters}) {
  const dt = useRef(null);
  const [open,setOpen] = useState(false);
  const options = [
    {
      name: "Supprimer",
      icone: <MdOutlineDelete style={styleIcone} />,
      isIdData: true,
      addMethodClick: true,
        methode: (idData) => {
          isDeleteType(idData);
        },
    },
  ];
  const isDeleteType = (id) => {
    console.log(id);
    setOpen(true);
  };
  const detailsInfo = (rowData) => {
    return <MenuPoint optionMenu={options} idData={rowData.id} />;
  };
  return (
    <div>
      <ModalDelete
        modalTitle={"Voulez-vous vraiment supprimer ce type ?"}
        setOpenMethod={setOpen}
        openProp={open}
        dataInfoForBtn={
        [{
          libelleBtn:"Oui",
          color:"error",
          methode:()=>{
            console.log("dff")
            // if(isRejectedBtn){
            //   changeStatut('refuse',valueTextField)
            // }
            // if(!isRejectedBtn){
            //   changeStatut('accepter')
            // }
          }
        },{
          libelleBtn:"Non",
          isStyle:true,
          methode:()=>{
             console.log("dff")
            // dispatch(showModal())
          }
        }]
      }
      />
      <TabView>
        <TabPanel>
          <DataTable
            ref={dt}
            value={items}
            tableStyle={{ minWidth: "50rem" }}
            paginator
            rows={10}
            filters={filters}
            globalFilterFields={["nom"]}
          >
            <Column
              field="label"
              style={{ textAlign: "center" }}
              header="type"
            ></Column>
            <Column 
            field="category.label" 
            style={{textAlign:"center"}} 
            header="Catégorie" 
           ></Column>
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Action"
              body={detailsInfo}
            ></Column>
          </DataTable>
        </TabPanel>
      </TabView>
    </div>
  );
}

export default ListeTypes;
